import React, {Component} from 'react';
import Picker from '../widgets/Picker';
import fetchJson from '../fetchJson';
import createPauser from '../pauser';

/**
 * Location drop down that executes a search on the back-end
 */
class LocationPicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			items: []
		};

		this.performSearch = createPauser(async search => {
			try {
				this.setState({
					loading: true
				});
				const items = (await fetchJson(
					`/api/location/search/${encodeURIComponent(search || 'WA')}`
				)).map(item => ({
					value: item.suburbUuid,
					label: item.suburb,
					extra: item.postcode,
					data: item
				}));
				this.setState({
					loading: false
				});
				this.setState({items});
			} catch (e) {
				console.error(e);
				this.props.onError();
			}
		}, 500);
		this.onSearchChange = e => this.performSearch(e.target.value);
	}

	componentDidMount() {
		this.performSearch('WA');
	}

	render() {
		return (
			<Picker
				loading={this.state.loading}
				title="Choose a location"
				searchPlaceholder="Search for a suburb, postcode, etc"
				selectionMapper={item => item && item.data}
				onChangeSearch={this.onSearchChange}
				items={this.state.items}
			/>
		);
	}
}

export default LocationPicker;



// WEBPACK FOOTER //
// ./src/search/LocationPicker.js